module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dmDsG2/tc-custom/9780811762120.jpg?1724846793109",
      "alt": "This image is the cover for the book Goodbye, Transylvania, Stackpole Military History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Goodbye, Transylvania, Stackpole Military History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A Romanian soldier details serving for Germany on the Eastern Front during World War II in this memoir, featuring firsthand accounts of combat.")])]), _vm._v(" German by ancestry, born and raised in the ethnic welter of post-World War I Romania, Sigmund Heinz Landau left his home to volunteer for the Third Reich during World War II. Serving on the Eastern Front, he saw nearly six years of continuous fighting with a "), _c('i', [_vm._v("Luftwaffe")]), _vm._v(" Flak unit and eventually in the "), _c('i', [_vm._v("Waffen-SS")]), _vm._v(", from sentry duty to desperate attacks against Soviet T-34s, from the siege of Budapest to the final campaign for Berlin in 1945. Landau’s memoir, written from a unique perspective, offers rare insight into what motivated soldiers to fight—and die—for Nazi Germany. \n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sigmund Heinz Landau\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sigmund Heinz Landau was born in Transylvania in 1920.  After the war Landau moved to England, where he died in 1998.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Stackpole Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0